import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Gift.css";

const SUPPORTED_LANGUAGES = [
  "en", "sw", "pt", "fr", "es", "pt-AO", "ar", "zh", "hi", "bn", "ru", "de", "it", "nl", "tr", "ja", "ko", "vi", "th", "id", "ms", "ur", "fa", "ha", "yo", "zu", "am", "so", "rw", "lg", "af",
];

const normalizeLanguage = (value) => {
  if (!value || typeof value !== "string") return "en";
  const cleaned = value.trim().replaceAll("_", "-");
  const exact = SUPPORTED_LANGUAGES.find((lang) => lang.toLowerCase() === cleaned.toLowerCase());
  if (exact) return exact;
  const base = cleaned.split("-")[0].toLowerCase();
  return SUPPORTED_LANGUAGES.includes(base) ? base : "en";
};

const getSavedLanguage = () => {
  try {
    return normalizeLanguage(
      localStorage.getItem("language") ||
      localStorage.getItem("appLanguage") ||
      localStorage.getItem("lang") ||
      "en"
    );
  } catch {
    return "en";
  }
};

const translations = {
  en: {
    bonusCenter: "BONUS CENTER", heading: "Promotions", headingAccent: "& Bonuses",
    intro: "Choose the promotion that suits you and", claim: " claim your bonus ", introEnd: "according to the deposit terms.",
    available: "AVAILABLE OFFERS", choose: "Choose Your Bonus", live: "LIVE",
    firstDeposit: "FIRST DEPOSIT", secondDeposit: "SECOND DEPOSIT", wednesday: "WEDNESDAY", weekly: "WEEKLY",
    firstMobile: "First Deposit Bonus (Mobile)", firstMobileDesc: "Make your first deposit and get a 10% bonus on your TZS balance.",
    secondMobile: "Second Deposit Bonus (Mobile)", secondMobileDesc: "Make your second deposit and get a bonus based on your deposit amount.",
    wednesdayTitle: "Wednesday Bonus (Mobile)", wednesdayDesc: "This bonus is available if you make a deposit on Wednesday.",
    firstUsdt: "First Deposit Bonus (USDT)", firstUsdtDesc: "Unlock a bonus with your first deposit using USDT.",
    secondUsdt: "Second Deposit Bonus (USDT)", secondUsdtDesc: "This bonus is available when you make your second deposit using USDT.",
    weeklyUsdt: "Weekly Deposit Bonus (USDT)", weeklyUsdtDesc: "Get a weekly bonus on an eligible deposit made using USDT.",
    infoTitle: "How Bonuses Work", infoDesc: "A bonus can be claimed only once for each eligible promotion. The system will check your deposit before approving the bonus.",
    open: "Open", 
  },
  sw: {
    bonusCenter: "KITUO CHA BONASI", heading: "Matangazo", headingAccent: "na Bonasi",
    intro: "Chagua promotion inayokufaa na", claim: " chukua bonasi yako ", introEnd: "kulingana na masharti ya amana.",
    available: "OFa ZINAZOPATIKANA", choose: "Chagua Bonasi Yako", live: "INAENDELEA",
    firstDeposit: "AMANA YA KWANZA", secondDeposit: "AMANA YA PILI", wednesday: "JUMATANO", weekly: "KILA WIKI",
    firstMobile: "Bonasi ya Amana ya Kwanza (Simu)", firstMobileDesc: "Weka amana yako ya kwanza na upate bonasi ya 10% kwenye salio lako la TZS.",
    secondMobile: "Bonasi ya Amana ya Pili (Simu)", secondMobileDesc: "Weka amana yako ya pili na upate bonasi kulingana na kiasi cha amana yako.",
    wednesdayTitle: "Bonasi ya Jumatano (Simu)", wednesdayDesc: "Bonasi hii inapatikana ukiweka amana siku ya Jumatano.",
    firstUsdt: "Bonasi ya Amana ya Kwanza (USDT)", firstUsdtDesc: "Pata nafasi ya bonasi kupitia amana yako ya kwanza kwa kutumia USDT.",
    secondUsdt: "Bonasi ya Amana ya Pili (USDT)", secondUsdtDesc: "Bonasi hii inapatikana ukiweka amana yako ya pili kupitia USDT.",
    weeklyUsdt: "Bonasi ya Amana ya Kila Wiki (USDT)", weeklyUsdtDesc: "Pata bonasi ya kila wiki kwa amana inayostahili kupitia USDT.",
    infoTitle: "Jinsi Bonasi Zinavyofanya Kazi", infoDesc: "Bonasi inaweza kudaiwa mara moja tu kwa kila promotion inayostahili. Mfumo utakagua amana yako kabla ya kuidhinisha bonasi.",
    open: "Fungua",
  },
  pt: {
    bonusCenter: "CENTRO DE BÔNUS", heading: "Promoções", headingAccent: "e Bônus",
    intro: "Escolha a promoção ideal para si e", claim: " receba o seu bônus ", introEnd: "de acordo com as condições do depósito.",
    available: "OFERTAS DISPONÍVEIS", choose: "Escolha o Seu Bônus", live: "ATIVO",
    firstDeposit: "PRIMEIRO DEPÓSITO", secondDeposit: "SEGUNDO DEPÓSITO", wednesday: "QUARTA-FEIRA", weekly: "SEMANAL",
    firstMobile: "Bônus do Primeiro Depósito (Mobile)", firstMobileDesc: "Faça o primeiro depósito e receba um bônus de 10% no saldo TZS.",
    secondMobile: "Bônus do Segundo Depósito (Mobile)", secondMobileDesc: "Faça o segundo depósito e receba um bônus conforme o valor depositado.",
    wednesdayTitle: "Bônus de Quarta-feira (Mobile)", wednesdayDesc: "Este bônus está disponível se fizer um depósito na quarta-feira.",
    firstUsdt: "Bônus do Primeiro Depósito (USDT)", firstUsdtDesc: "Desbloqueie um bônus com o seu primeiro depósito em USDT.",
    secondUsdt: "Bônus do Segundo Depósito (USDT)", secondUsdtDesc: "Este bônus está disponível no segundo depósito feito com USDT.",
    weeklyUsdt: "Bônus de Depósito Semanal (USDT)", weeklyUsdtDesc: "Receba um bônus semanal num depósito elegível feito com USDT.",
    infoTitle: "Como Funcionam os Bônus", infoDesc: "Cada promoção elegível permite reclamar o bônus apenas uma vez. O sistema verificará o seu depósito antes de aprovar o bônus.", open: "Abrir",
  },
  fr: {
    bonusCenter: "CENTRE DES BONUS", heading: "Promotions", headingAccent: "et bonus",
    intro: "Choisissez la promotion qui vous convient et", claim: " réclamez votre bonus ", introEnd: "selon les conditions de dépôt.",
    available: "OFFRES DISPONIBLES", choose: "Choisissez votre bonus", live: "EN DIRECT",
    firstDeposit: "PREMIER DÉPÔT", secondDeposit: "DEUXIÈME DÉPÔT", wednesday: "MERCREDI", weekly: "HEBDOMADAIRE",
    firstMobile: "Bonus de premier dépôt (mobile)", firstMobileDesc: "Effectuez votre premier dépôt et obtenez un bonus de 10 % sur votre solde TZS.",
    secondMobile: "Bonus de deuxième dépôt (mobile)", secondMobileDesc: "Effectuez votre deuxième dépôt et obtenez un bonus selon le montant déposé.",
    wednesdayTitle: "Bonus du mercredi (mobile)", wednesdayDesc: "Ce bonus est disponible si vous effectuez un dépôt le mercredi.",
    firstUsdt: "Bonus de premier dépôt (USDT)", firstUsdtDesc: "Débloquez un bonus avec votre premier dépôt en USDT.",
    secondUsdt: "Bonus de deuxième dépôt (USDT)", secondUsdtDesc: "Ce bonus est disponible lors de votre deuxième dépôt en USDT.",
    weeklyUsdt: "Bonus de dépôt hebdomadaire (USDT)", weeklyUsdtDesc: "Obtenez un bonus hebdomadaire pour un dépôt admissible en USDT.",
    infoTitle: "Fonctionnement des bonus", infoDesc: "Un bonus ne peut être réclamé qu'une seule fois pour chaque promotion admissible. Le système vérifiera votre dépôt avant d'approuver le bonus.", open: "Ouvrir",
  },
  es: {
    bonusCenter: "CENTRO DE BONOS", heading: "Promociones", headingAccent: "y Bonos",
    intro: "Elige la promoción que más te convenga y", claim: " reclama tu bono ", introEnd: "según las condiciones del depósito.",
    available: "OFERTAS DISPONIBLES", choose: "Elige tu bono", live: "ACTIVO",
    firstDeposit: "PRIMER DEPÓSITO", secondDeposit: "SEGUNDO DEPÓSITO", wednesday: "MIÉRCOLES", weekly: "SEMANAL",
    firstMobile: "Bono del primer depósito (móvil)", firstMobileDesc: "Haz tu primer depósito y recibe un bono del 10 % en tu saldo TZS.",
    secondMobile: "Bono del segundo depósito (móvil)", secondMobileDesc: "Haz tu segundo depósito y recibe un bono según el importe depositado.",
    wednesdayTitle: "Bono del miércoles (móvil)", wednesdayDesc: "Este bono está disponible si haces un depósito el miércoles.",
    firstUsdt: "Bono del primer depósito (USDT)", firstUsdtDesc: "Desbloquea un bono con tu primer depósito mediante USDT.",
    secondUsdt: "Bono del segundo depósito (USDT)", secondUsdtDesc: "Este bono está disponible al hacer tu segundo depósito mediante USDT.",
    weeklyUsdt: "Bono de depósito semanal (USDT)", weeklyUsdtDesc: "Obtén un bono semanal por un depósito válido mediante USDT.",
    infoTitle: "Cómo funcionan los bonos", infoDesc: "Cada promoción válida permite reclamar el bono una sola vez. El sistema comprobará tu depósito antes de aprobarlo.", open: "Abrir",
  },
  de: {
    bonusCenter: "BONUSZENTRUM", heading: "Aktionen", headingAccent: "und Boni",
    intro: "Wähle die passende Aktion und", claim: " sichere dir deinen Bonus ", introEnd: "gemäß den Einzahlungsbedingungen.",
    available: "VERFÜGBARE ANGEBOTE", choose: "Wähle deinen Bonus", live: "LIVE",
    firstDeposit: "ERSTE EINZAHLUNG", secondDeposit: "ZWEITE EINZAHLUNG", wednesday: "MITTWOCH", weekly: "WÖCHENTLICH",
    firstMobile: "Bonus für die erste Einzahlung (Mobil)", firstMobileDesc: "Zahle zum ersten Mal ein und erhalte 10 % Bonus auf dein TZS-Guthaben.",
    secondMobile: "Bonus für die zweite Einzahlung (Mobil)", secondMobileDesc: "Zahle zum zweiten Mal ein und erhalte einen Bonus abhängig vom Einzahlungsbetrag.",
    wednesdayTitle: "Mittwochsbonus (Mobil)", wednesdayDesc: "Dieser Bonus ist verfügbar, wenn du am Mittwoch einzahlst.",
    firstUsdt: "Bonus für die erste Einzahlung (USDT)", firstUsdtDesc: "Schalte mit deiner ersten USDT-Einzahlung einen Bonus frei.",
    secondUsdt: "Bonus für die zweite Einzahlung (USDT)", secondUsdtDesc: "Dieser Bonus ist bei deiner zweiten Einzahlung mit USDT verfügbar.",
    weeklyUsdt: "Wöchentlicher Einzahlungsbonus (USDT)", weeklyUsdtDesc: "Erhalte einen Wochenbonus für eine berechtigte Einzahlung mit USDT.",
    infoTitle: "So funktionieren Boni", infoDesc: "Jeder berechtigte Bonus kann pro Aktion nur einmal beansprucht werden. Das System prüft deine Einzahlung vor der Freigabe.", open: "Öffnen",
  },
  ar: {
    bonusCenter: "مركز المكافآت", heading: "العروض الترويجية", headingAccent: "والمكافآت",
    intro: "اختر العرض المناسب لك و", claim: " احصل على مكافأتك ", introEnd: "وفقًا لشروط الإيداع.",
    available: "العروض المتاحة", choose: "اختر مكافأتك", live: "مباشر",
    firstDeposit: "الإيداع الأول", secondDeposit: "الإيداع الثاني", wednesday: "الأربعاء", weekly: "أسبوعي",
    firstMobile: "مكافأة الإيداع الأول (الهاتف)", firstMobileDesc: "أجرِ أول إيداع واحصل على مكافأة 10٪ على رصيد TZS.",
    secondMobile: "مكافأة الإيداع الثاني (الهاتف)", secondMobileDesc: "أجرِ الإيداع الثاني واحصل على مكافأة حسب مبلغ الإيداع.",
    wednesdayTitle: "مكافأة الأربعاء (الهاتف)", wednesdayDesc: "تتوفر هذه المكافأة عند إجراء إيداع يوم الأربعاء.",
    firstUsdt: "مكافأة الإيداع الأول (USDT)", firstUsdtDesc: "افتح مكافأة مع أول إيداع باستخدام USDT.",
    secondUsdt: "مكافأة الإيداع الثاني (USDT)", secondUsdtDesc: "تتوفر هذه المكافأة عند إجراء الإيداع الثاني باستخدام USDT.",
    weeklyUsdt: "مكافأة الإيداع الأسبوعية (USDT)", weeklyUsdtDesc: "احصل على مكافأة أسبوعية عند إجراء إيداع مؤهل باستخدام USDT.",
    infoTitle: "كيف تعمل المكافآت", infoDesc: "يمكن المطالبة بالمكافأة مرة واحدة فقط لكل عرض مؤهل. سيتحقق النظام من إيداعك قبل الموافقة على المكافأة.", open: "فتح",
  },
  zh: {
    bonusCenter: "奖励中心", heading: "促销活动", headingAccent: "与奖励",
    intro: "选择适合您的活动并", claim: " 领取您的奖励 ", introEnd: "请遵守存款条件。",
    available: "可用优惠", choose: "选择您的奖励", live: "进行中",
    firstDeposit: "首次存款", secondDeposit: "第二次存款", wednesday: "星期三", weekly: "每周",
    firstMobile: "首次存款奖励（手机）", firstMobileDesc: "首次存款即可获得 TZS 余额 10% 的奖励。",
    secondMobile: "第二次存款奖励（手机）", secondMobileDesc: "第二次存款可根据存款金额获得奖励。",
    wednesdayTitle: "星期三奖励（手机）", wednesdayDesc: "星期三存款即可参加此奖励活动。",
    firstUsdt: "首次存款奖励（USDT）", firstUsdtDesc: "使用 USDT 首次存款即可解锁奖励。",
    secondUsdt: "第二次存款奖励（USDT）", secondUsdtDesc: "使用 USDT 进行第二次存款即可获得此奖励。",
    weeklyUsdt: "每周存款奖励（USDT）", weeklyUsdtDesc: "使用 USDT 进行符合条件的存款即可获得每周奖励。",
    infoTitle: "奖励规则说明", infoDesc: "每项符合条件的活动只能领取一次奖励。系统会在批准奖励前核实您的存款。", open: "打开",
  },
  hi: {
    bonusCenter: "बोनस केंद्र", heading: "प्रमोशन", headingAccent: "और बोनस",
    intro: "अपने लिए उपयुक्त ऑफ़र चुनें और", claim: " अपना बोनस प्राप्त करें ", introEnd: "जमा की शर्तों के अनुसार।",
    available: "उपलब्ध ऑफ़र", choose: "अपना बोनस चुनें", live: "लाइव",
    firstDeposit: "पहली जमा", secondDeposit: "दूसरी जमा", wednesday: "बुधवार", weekly: "साप्ताहिक",
    firstMobile: "पहली जमा बोनस (मोबाइल)", firstMobileDesc: "पहली जमा करें और अपने TZS बैलेंस पर 10% बोनस पाएँ।",
    secondMobile: "दूसरी जमा बोनस (मोबाइल)", secondMobileDesc: "दूसरी जमा करें और जमा राशि के अनुसार बोनस पाएँ।",
    wednesdayTitle: "बुधवार बोनस (मोबाइल)", wednesdayDesc: "बुधवार को जमा करने पर यह बोनस उपलब्ध है।",
    firstUsdt: "पहली जमा बोनस (USDT)", firstUsdtDesc: "USDT से पहली जमा करके बोनस अनलॉक करें।",
    secondUsdt: "दूसरी जमा बोनस (USDT)", secondUsdtDesc: "USDT से दूसरी जमा करने पर यह बोनस उपलब्ध है।",
    weeklyUsdt: "साप्ताहिक जमा बोनस (USDT)", weeklyUsdtDesc: "योग्य USDT जमा पर साप्ताहिक बोनस पाएँ।",
    infoTitle: "बोनस कैसे काम करते हैं", infoDesc: "हर योग्य प्रमोशन पर बोनस केवल एक बार लिया जा सकता है। बोनस मंज़ूर करने से पहले सिस्टम आपकी जमा की जाँच करेगा।", open: "खोलें",
  },
};

const getText = (language, key) => translations[language]?.[key] || translations.en[key] || key;

const PromotionsPage = () => {
  const navigate = useNavigate();
  const [language, setLanguage] = useState(getSavedLanguage);

  useEffect(() => {
    const updateLanguage = (event) => {
      const detailLanguage = typeof event?.detail === "string"
        ? event.detail
        : event?.detail?.language;
      setLanguage(normalizeLanguage(detailLanguage || getSavedLanguage()));
    };
    const onStorage = (event) => {
      if (!event?.key || ["language", "appLanguage", "lang"].includes(event.key)) {
        setLanguage(getSavedLanguage());
      }
    };
    window.addEventListener("languageChanged", updateLanguage);
    window.addEventListener("storage", onStorage);
    window.addEventListener("focus", onStorage);
    return () => {
      window.removeEventListener("languageChanged", updateLanguage);
      window.removeEventListener("storage", onStorage);
      window.removeEventListener("focus", onStorage);
    };
  }, []);

  const t = (key) => getText(language, key);
  const promos = [
    { id: 1, icon: "🎁", tag: t("firstDeposit"), title: t("firstMobile"), desc: t("firstMobileDesc"), rate: "10%", route: "/FirstDepositBonus", type: "green" },
    { id: 2, icon: "🎯", tag: t("secondDeposit"), title: t("secondMobile"), desc: t("secondMobileDesc"), rate: "5% – 8%", route: "/SecondDepositBonus", type: "purple" },
    { id: 3, icon: "📅", tag: t("wednesday"), title: t("wednesdayTitle"), desc: t("wednesdayDesc"), rate: "5%", route: "/WeeklyDepositBonus", type: "orange" },
    { id: 4, icon: "💵", tag: t("firstDeposit"), title: t("firstUsdt"), desc: t("firstUsdtDesc"), rate: "BONUS", route: "/FirstDepositBonusUSDT", type: "blue" },
    { id: 5, icon: "💎", tag: t("secondDeposit"), title: t("secondUsdt"), desc: t("secondUsdtDesc"), rate: "BONUS", route: "/SecondDepositBonusUSDT", type: "cyan" },
    { id: 6, icon: "📆", tag: t("weekly"), title: t("weeklyUsdt"), desc: t("weeklyUsdtDesc"), rate: "BONUS", route: "/Weekly/Deposit/BonusUSDT", type: "orange" },
  ];
  const openPromotion = (route) => navigate(route);
  const isRtl = ["ar", "ur", "fa"].includes(language);

  return (
    <div className="promo-page" dir={isRtl ? "rtl" : "ltr"}>
      <div className="promo-orb promo-orb-one" />
      <div className="promo-orb promo-orb-two" />

      <header className="promo-header">
        <div className="promo-top-badge"><span>✦</span> {t("bonusCenter")}</div>
        <h1>{t("heading")} <span>{t("headingAccent")}</span></h1>
        <p>{t("intro")}<strong>{t("claim")}</strong>{t("introEnd")}</p>
      </header>

      <section className="promo-section">
        <div className="promo-section-title">
          <div><span>{t("available")}</span><h2>{t("choose")}</h2></div>
          <div className="promo-live"><i />{t("live")}</div>
        </div>

        <div className="promo-list">
          {promos.map((promo) => (
            <article
              key={promo.id}
              className={`promo-list-card promo-${promo.type}`}
              onClick={() => openPromotion(promo.route)}
              role="button"
              tabIndex={0}
              onKeyDown={(event) => {
                if (event.key === "Enter" || event.key === " ") {
                  event.preventDefault();
                  openPromotion(promo.route);
                }
              }}
            >
              <div className="promo-list-icon">{promo.icon}</div>
              <div className="promo-list-content"><h3>{promo.title}</h3><p>{promo.desc}</p></div>
              <div className="promo-list-right"><div className="promo-list-tag">{promo.tag}</div><strong className="promo-list-rate">{promo.rate}</strong></div>
              <button
                type="button"
                className="promo-list-arrow"
                onClick={(event) => { event.stopPropagation(); openPromotion(promo.route); }}
                aria-label={`${t("open")} ${promo.title}`}
              >→</button>
            </article>
          ))}
        </div>
      </section>

      <div className="promo-info">
        <div className="promo-info-icon">💡</div>
        <div><strong>{t("infoTitle")}</strong><p>{t("infoDesc")}</p></div>
      </div>
    </div>
  );
};

export default PromotionsPage;
